import * as React from 'react';
import { Body, ContainerRules, InputText, Container2, ContainerEditAccordion, GreenBox, RedBox } from './styles';

import Typography from '@mui/material/Typography';

import Header from '../../components/Header';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import { atualizarWebhook, sendImage, sendMessageAll, sendMessageWitchButton, setNewClient } from '../../services';
import base64 from 'base-64';
import { getDatabase, ref, set, push, get, child, onValue, update, remove } from "firebase/database";
import { database } from '../../App';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SaveIcon from '@mui/icons-material/Save';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';
import AccountBoxOutlined from '@mui/icons-material/AccountBoxOutlined';
import { getAuth, onAuthStateChanged,signOut } from "firebase/auth";
import "firebase/database";
import { dataInstance } from '../../services';
import styled from 'styled-components';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { setItem } from '../../storage/serviceState';





const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const style = {
    minHeight: 300,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 500,
    bgcolor: 'white',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    gap: 15,

    // Responsivo com breakpoints do MUI
    '@media (max-width:720px)': {
        minWidth: '70%',
        height: 'auto',
        p: 2,
    },
};

const styleFuncServ = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 15,

    // Responsivo com breakpoints do MUI
    '@media (max-width:720px)': {
        flexDirection: 'column'
    },
};


const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999
};

const modalBox = {
  width: "500px",
  background: "white",
  padding: "30px",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "12px"
};

const styleModalRegister = {
    maxHeight: '100vh',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 1,
    overflowY: 'auto'
};

const styleModalList = {
    height: '86%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 1
};


const actions = [
    { icon: <AccountBoxOutlined style={{ color: '#42adda', backgroundColor: '#0073b1' }} />, name: 'Cadastrar Funcionário' },
    { icon: <AccountBoxOutlined style={{ color: '#42adda', backgroundColor: '#0073b1' }} />, name: 'Cadastrar Serviços' },
    { icon: <AccountBoxOutlined style={{ color: '#42adda', backgroundColor: '#0073b1' }} />, name: 'Cadastrar Produtos' },

];


const employees = ["Carlos", "Maria", "João", "Ana", "Pedro"];
const workHours = ["10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30"];
const weekDays = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta"];




const Measurement = () => {
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const [openRegister, setOpenRegister] = React.useState(false);
    const [openProduct, setOpenProduct] = React.useState(false);
    const [openList, setOpenList] = React.useState(false);
    const [datarow, setDataRow] = React.useState(false);
    const [dataClientes, setDataClientes] = React.useState([]);
    const [clientesRecompra, setClientesRecompra] = React.useState([]);
    const [time, setTime] = React.useState('');
    const [formattedTime, setFormattedTime] = React.useState('');
    const [date, setDate] = React.useState('');
    const [filteredData, setFilteredData] = React.useState([]);
    const [filterValue, setFilterValue] = React.useState('');
    const [user, setUser] = React.useState(false);
    const [novaData, setNovaData] = React.useState(null);
    const [clientForTime, setClientforTime] = React.useState([{ clientes: [] }]);
    const [connectednumber, setConnectedNumber] = React.useState(false);
    const [userData, setUserData] = React.useState({ servicos: [] });
    const listRef = React.useRef(null);
    const [paymentState, setPaymentState] = React.useState({ assinatura: false });
    const [dataRowRecompra, setDataRowRecompra] = React.useState('');
    const [relatorio, setRelatorio] = React.useState('');
    const [messageDataUser, setMessageDataUser] = React.useState(false);
    const [paymentLinks, setPaymentLinks] = React.useState([]);
    const [isCopied, setIsCopied] = React.useState(false);
    const [isLink, setLink] = React.useState('');



    const [bookedAppointments, setBookedAppointments] = React.useState([]);
    const [availableTimes, setAvailableTimes] = React.useState([]);
    const [selectedTime, setSelectedTime] = React.useState(null);
    const [selectedEmployee, setSelectedEmployee] = React.useState(null);
    const [userMessage, setUserMessage] = React.useState("");
    const [nextBooked, setNextBooked] = React.useState(null);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [userState, setUserState] = React.useState();
    const [proxAgendar, setProxAgendar] = React.useState(false);
    const [servicoSelecionado, setServicoSelecionado] = React.useState(false);
    const [availableEmployeesa, setAvailableEmployees] = React.useState([]);
    const [cargoFuncionario, setCargoFuncionario] = React.useState('');
    const [nomeFuncionario, setNomeFuncionario] = React.useState('');
    const [etapaConfirm, setEtapaConfirm] = React.useState(false);
    const [nomeServico, setNomeServico] = React.useState('');
    const [valorServico, setValorServico] = React.useState('');
    const [nomeProduto, setNomeProduto] = React.useState('');
    const [valorProduto, setValorProduto] = React.useState('');
    const [descricaoProduto, setDescricaoProduto] = React.useState('');
    const [etapaDate, setEtapaDate] = React.useState('');
    const [horarioManual, setManualHorarios] = React.useState([]);
    const [dateManual, setDateManual] = React.useState('');
    const [employeesManual, setEmployeesManual] = React.useState([]);
    const [selectedHorarioManual, setSelectedHorarioManual] = React.useState('');
    const [servicosManual, setServicosManual] = React.useState({ servicosSelecionados: [] });
    const [selectedServicosManual, setSelectedServicoManual] = React.useState([]);
    const [selectedEmployeeManual, setSelectedEmployeeManual] = React.useState([]);
    const [nomeClienteManual, setNomeClienteManual] = React.useState('');
    const [numeroClienteManual, setNumeroClienteManual] = React.useState('');
    const [atendimentoEtapa, setAtendimentoEtapa] = React.useState(false);
    const [attendedAppointments, setAttendedAppointments] = React.useState([]);
    const [descricaoServico, setDescricaoServico] = React.useState('');
    const [openQr, setOpenQr] = React.useState(false);
    const [ qrCodeValue, setQrCodeValue ] = React.useState('')
  

React.useEffect(() => {
  const auth = getAuth();

  signOut(auth)
    .then(p => {
      console.log(p)
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

    const qrCodeUrl = qrCodeValue;

const handleOpenQr = () => {
    getQrCode()
    setOpenQr(true);

}
const handleCloseQr = () => setOpenQr(false);
    const db = getDatabase();



    const handleChangeHorario = (event) => {
        setSelectedHorarioManual(event.target.value);
    };

    const handleChangeFuncionario = (event) => {
        setEmployeesManual(event.target.value);
    };

    const handleChangeServicos = (event) => {
        const selectedValues = event.target.value;
        console.log(selectedValues)
        setServicosManual(selectedValues);
    };








    const ContainerT = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width:100%
  padding: 20px;
  align-items:center;
  justify-content:center;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;



    const Card = styled.div`
  background-color: #0073b1;
  color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

    const CardR = styled.div`
background-color: #42adda;
color: white;
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
text-align: center;
transition: transform 0.3s;

&:hover {
  transform: translateY(-5px);
}
`;

    const TitleT = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
`;

    const Value = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
`;

    const Percentage = styled.div`
  font-size: 1.2rem;
  color: #28a745;
  margin-top: 10px;
`;

    const CardT = styled.div`
  display: flex;
  align-items: center;
  background: #e3f2fd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  transition: transform 0.3s ease-in-out;
  width:80%
  height:400px;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width:80%;
  }
`;

    const Icon = styled.div`
  background: #64b5f6;
  padding: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: white;
  font-size: 26px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
`;

    const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

    const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #1565c0;
  font-weight: bold;
`;

    const Time = styled.p`
  margin: 5px 0 0;
  font-size: 16px;
  color: #424242;
  font-weight: 500;
`;

    const Details = styled.p`
  margin: 5px 0 0;
  font-size: 14px;
  color: #616161;
  font-style: italic;
`;


    const ServiceCardContainer = styled.div`
  position: relative;
  width: 100px;
  padding: 24px;
  background: linear-gradient(145deg, #ffffff, #f5f5f5);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: radial-gradient(circle at 70% 30%, rgba(106, 17, 203, 0.1) 0%, transparent 70%);
  }
`;

    const ServiceTitle = styled.h3`
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
`;

    const ServiceDescription = styled.p`
  margin: 0 0 16px 0;
  color: #666;
  font-size: 13;
  line-height: 1.5;
`;

    const ServicePrice = styled.span`
  display: inline-block;
  padding: 6px 12px;
  background: rgba(37, 117, 252, 0.1);
  color: #2575fc;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
`;

    const DeleteButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  background: rgba(255, 0, 0, 0.1);
  border: none;
  border-radius: 50%;
  color: #ff4444;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 0, 0, 0.2);
    transform: scale(1.1);
  }
`;

    const CopyContainer = styled.div`
  display: flex;
  max-width: 600px;
  margin: 10px auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
`;

    const LinkInput = styled.input`
  flex: 1;
  padding: 10px 15px;
  border: none;
  outline: none;
  font-size: 16px;
  background-color: #f5f5f5;

  &:focus {
    background-color: #fff;
  }
`;

    const CopyButton = styled.button`
  padding: 0 15px;
  border: none;
  background-color: ${props => props.isCopied ? '#4CAF50' : '#2196F3'};
  color: white;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.3s;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : props.isCopied ? '#45a049' : '#0b7dda'};
  }

  &:disabled {
    background-color: #ccc;
  }
`;


    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleOpenRegister = () => setOpenRegister(true);
    const handleCloseRegister = () => setOpenRegister(false);

    const handleOpenProduct = () => setOpenProduct(true);
    const handleCloseProduct = () => setOpenProduct(false);

    const handleOpenList = () => setOpenList(true);
    const handleCloseList = () => setOpenList(false);
    const columns = [
        { field: 'service', headerName: 'Serviço:', width: 150 },
        { field: 'clientName', headerName: 'Nome', width: 130 },
        { field: 'employeeName', headerName: 'Quem Atende', width: 150 },
        { field: 'time', headerName: 'Horário', width: 130 },
        { field: 'date', headerName: 'Data ( para ):', width: 150 },
        { field: 'clientPhone', headerName: 'Contato', width: 150 },
        { field: 'serviceValue', headerName: 'Valor do Serviço', width: 150 },
        { field: 'id', headerName: 'ID', width: 150 }

    ];

    const columnsComprados = [
        { field: 'clientPhone', headerName: 'Telefone Cliente:', width: 150 },
        { field: 'selectedProduct', headerName: 'Nome', width: 130 },
    ];


    const services = [
        { nome: "Corte de Cabelo", preco: "R$30" },
        { nome: "Barba", preco: "R$20" },
        { nome: "Corte + Barba", preco: "R$45" }
    ];


    const data = [
        { title: "Serviços Agendados", value: relatorio ? relatorio.clientes : 0, percentage: "+0%" },
        { title: "Produtos Vendidos", value: relatorio.clientesAtendidos ? relatorio.clientesAtendidos : 0, percentage: "+0%" },
        { title: "Receita Líquida", value: `R$ ${relatorio.valorEmClientes ? relatorio.valorEmClientes.toFixed(2).replace('.', ',') : 0}`, percentage: "+0%" },

        //    { title: "Receita Líquida", value: `R$ ${relatorio.valorEmClientesAtendidos ? relatorio.valorEmClientesAtendidos.toFixed(2).replace('.', ',') : 0}`, percentage: "+0%" },
    ];

    const paginationModel = { page: 0, pageSize: 5 };

    const getQrCode = async () => {
  try {
    const response = await fetch(
      "https://api.z-api.io/instances/3F4B2502EB75B16A4F749202A3FD2FF8/token/23D2C28D70F691D4D97D0CF0/qr-code/image",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Client-Token": "Fb62a216ab97f4d3e9c85b77e786a41ecS"
        }
      }
    );

    const data = await response.json();

    console.log(data);

    // ajuste conforme retorno real da sua conta
    setQrCodeValue(data.value); 
    setOpenQr(true);

  } catch (error) {
    console.log(error);
    alert("Erro ao carregar QR Code");
  }
};



    async function dataInstanceValue() {
        const idi = '3E019F6A2AD3400FBE778E66062CE0C1';

        const tokeni = '0F4CC44688C0009373197BB4';

        try {
            const response = await dataInstance(idi, tokeni); // Aguarda a função retornar o resultado
            console.log('DATAAQUI:::::::', response)
            if (response.connected) {
                setConnectedNumber(true)
            } else {
                setConnectedNumber(false)
            }
        } catch (error) {
            console.error('TRYCAYCHERROR:::::QRCODE:::', error); // Lida com erros
        }
    }

    const handleRowSelection = (selectedId) => {
        console.log('--- INÍCIO DA SELEÇÃO ---');
        console.log('ID recebido:', selectedId, 'Tipo:', typeof selectedId);

        // Verifica se bookedAppointments existe e tem dados
        console.log('Total de agendamentos:', bookedAppointments?.length || 0);

        if (!bookedAppointments || bookedAppointments.length === 0) {
            console.error('Nenhum dado em bookedAppointments');
            setDataRow([]);
            return;
        }

        // Busca o item correspondente (com verificação de tipo)
        const selectedRowData = bookedAppointments.find((row) => {
            console.log(`Comparando: row.id=${row.id} (${typeof row.id}) com selectedId=${selectedId} (${typeof selectedId})`);
            return row.id == selectedId; // Usamos == para compatibilidade de tipos
        });

        if (!selectedRowData) {
            console.warn('Nenhum dado encontrado para o ID:', selectedId);
        } else {
            console.log('Dados encontrados:', selectedRowData);
        }

        setDataRow(selectedRowData ? [selectedRowData] : []);
    };

    console.log('ATENDIDOVALORES::::::::::::::', relatorio)

    const handleRowRecompra = (selectionModel) => {
        // Pegar os dados das linhas selecionadas
        const selectedRowsData = clientesRecompra.filter((row) => selectionModel.includes(row.id));
        setDataRowRecompra(selectedRowsData);

        console.log('Linhas selecionadas:', selectedRowsData);
    };

    console.log('VALORR LINHA SELECIONADA', datarow[0]);

    const clientesAtendidos = () => {
        const db = getDatabase();

        const postData = {
            time: datarow[0].time,
            date: datarow[0].date,
            employee: datarow[0].employee,
            id: datarow[0].id,
            phone: datarow[0].phone,
            nome: datarow[0].nome,
            servico: datarow[0].servico,
            digit: datarow[0].digit,
            valorServico: datarow[0].valorServico,
            atendido: true
        };

        const updatesData = {};
        updatesData[`${base64.encode(user.email)}/agendamentos/${base64.encode(datarow[0].phone + datarow[0].digit)}`] = postData;
        update(ref(db), updatesData).then(() => {
            console.log('passou')

        }).catch(console.error);

        const post = {
            clientesAtendidos: parseFloat(relatorio?.clientesAtendidos) + 1,
            valorEmClientesAtendidos: parseFloat(relatorio?.valorEmClientesAtendidos) + parseFloat(datarow[0].valorServico),
            clientes: relatorio.clientes,
            valorEmClientes: parseFloat(relatorio.valorEmClientes)
        };

        const updates = {};
        updates[`${base64.encode(user.email)}/relatorios`] = post;
        update(ref(db), updates).then(() => {
            setAtendimentoEtapa(!atendimentoEtapa)
            alert('Atendimento concluído com Sucesso!')
        }).catch(console.error);

    }

    const deleteAgendamento = (selectionModel) => {
        const db = getDatabase();
        const post = {
            clientes: relatorio.clientes - 1,
            valorEmClientes: parseFloat(relatorio?.valorEmClientes),
            valorEmClientesAtendidos: parseFloat(relatorio?.valorEmClientesAtendidos),
            clientesAtendidos: parseFloat(relatorio?.clientesAtendidos)
        };



        remove(ref(db, `${base64.encode(user.email)}/agendamentos/${base64.encode(datarow[0].phone + datarow[0].digit)}`))
            .then(() => {
                const updates = {};
                updates[`${base64.encode(user.email)}/relatorios`] = post;
                update(ref(db), updates).then(() => alert('Agendamento Cancelado')).catch(console.error);
            })
            .catch(err => console.log(err));
    };

    console.log('REALTORIOSSSS:::::::::::::', relatorio.valorEmClientes)

    console.log('REALTORIOSSSSVALORSERVICOMANUAL:::::::::::::', servicosManual.valor)

    const cadastrarManualCliente = () => {

        if (!selectedHorarioManual || !dateManual || !employeesManual || !nomeClienteManual) {
            window.alert('Preencha os Campos!')
        } {
            const digit1 = bookedAppointments.length + 1

            const body = {
                message: `✅ Agendamento Confirmado com ${employeesManual} às ${selectedHorarioManual} para ${servicosManual} no dia ${dateManual}.`,
                phone: `+${numeroClienteManual}`,
                delayMessage: 2
            };

            const db = getDatabase();
            set(ref(db, `${base64.encode(user.email)}/agendamentos/${base64.encode(numeroClienteManual + digit1)}`), {
                time: selectedHorarioManual,
                date: dateManual,
                employeeNme: employeesManual,
                id: digit1,
                clientPhone: numeroClienteManual,
                clientName: nomeClienteManual,
                servico: servicosManual.nome,
                digit: digit1,
                atendido: false,
                serviceValue: servicosManual.valor
            })
                .then(() => sendMessageAll(body))
                .catch(() => null);



            const post = {
                clientes: relatorio.clientes + 1,
                valorEmClientes: parseFloat(relatorio?.valorEmClientes) + parseFloat(servicosManual.valor),
                valorEmClientesAtendidos: parseFloat(relatorio?.valorEmClientesAtendidos),
                clientesAtendidos: parseFloat(relatorio?.clientesAtendidos)
            };

            const updates = {};
            updates[`${base64.encode(user.email)}/relatorios`] = post;
            update(ref(db), updates).catch(console.error);
            handleCloseList()
        }

    }




    React.useEffect(() => {

        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user)

                const appointmentsRef = ref(db, `${base64.encode(user.email)}`);
                setItem('user', user)

                onValue(appointmentsRef, (snapshot) => {
                    const data = snapshot.val()

                    if (data) {
                        const allAppointments = data.agendamentos
                            ? Object.entries(data.agendamentos).map(([key, appt]) => ({
                                id: key,
                                service: appt.service,
                                clientName: appt.clientName,
                                employeeName: appt.employeeName,
                                time: appt.time,
                                date: appt.date,
                                clientPhone: appt.clientPhone,
                                serviceValue: appt.serviceValue,
                                digit: appt.digit,
                                atendido: appt.atendido
                            }))
                            : [];

                        setBookedAppointments(allAppointments);

                        console.log('ALL APPOINTMENTS:', allAppointments);

                        /*   const attendedToday = allAppointments.filter(appt =>
                               appt.atendido === true && appt.date === todayFormatted
                           );*/
                        if (data.compras) {
                            const allBuys = Object.entries(data.compras).map(([key, appt]) => ({
                                id: key,
                                clientPhone: appt.clientPhone,
                                selectedProduct: appt.selectedProduct
                            }));
                            setAttendedAppointments(allBuys);
                        }

                    } else {
                        setBookedAppointments([]);
                        setAttendedAppointments([]);
                    }
                });

                const appointments = ref(db, `${base64.encode(user.email)}`);

                onValue(appointments, (snapshot) => {
                    setUserData(snapshot.val())
                    setLink(snapshot.val()?.nameBase64 ? `https://wa.me/5561990008359?text=${snapshot.val().nameBase64}` : null)
                });

                dataInstanceValue()

            }
        }
        )

    }, [user])






    console.log('agendamentos::::::::', selectedDate)


    /*          const isEmployeeAvailable = Array.isArray(bookedAppointments) && !bookedAppointments.some(
            (appt) => appt.time === selectedTime && appt.employee === userMessage
          ); 
          
         

          ---
          ---
          ---

       
          */


    React.useEffect(() => {
        if (bookedAppointments) {
            const next = getNextBookedTime(bookedAppointments);
            setNextBooked(next);
        }
    }, [bookedAppointments]);

    const getNextBookedTime = (bookedAppointments = []) => {
        if (!Array.isArray(bookedAppointments) || bookedAppointments.length === 0) {
            return null;
        }

        const sortedAppointments = [...bookedAppointments].sort((a, b) => {
            return a.time.localeCompare(b.time);
        });

        return sortedAppointments[0]; // Retorna o objeto inteiro { time, employee }
    };


    React.useEffect(() => {
        const dataa = getDatabase()
        const dbRef = ref(getDatabase());

        get(child(dbRef, `${base64.encode(user.email)}/relatorios`)).then((snapshot) => {
            if (snapshot.exists()) {
                setRelatorio(snapshot.val())
            } else {
                console.log("No data available");
            }
        }).catch((error) => {
            console.error(error);
        });

    }, [user, bookedAppointments])




    const handleChangeMenu = (event) => {

        if (event == 'Cadastrar Funcionário') {
            handleOpen()
        } else if (event == 'Cadastrar Serviços') {
            handleOpenRegister()
        } else if (event == 'Cadastrar Produtos') {
            handleOpenProduct()
        }


    };

    const handleCopy = async () => {
        if (!isLink) return;

        navigator.clipboard.writeText(isLink)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 2000);
            })
            .catch(err => {
                console.error('Falha ao copiar texto: ', err);
            });

    };

    const onDeleteService = (service) => {

        const db = getDatabase();
        remove(ref(db, `${base64.encode(user.email)}/servicos/${base64.encode(service.valor + service.nome)}`), {})
            .then(() => alert('Serviço removido!'))
            .catch(err => console.log(err));

    };

    const onDeleteEmployee = (service) => {

        const db = getDatabase();
        remove(ref(db, `${base64.encode(user.email)}/funcionarios/${base64.encode(service.nome + service.cargo)}`), {})
            .then(() => alert('Serviço removido!'))
            .catch(err => console.log(err));

    };

    async function registerFuncionario() {
        if (!nomeFuncionario || !cargoFuncionario) {
            window.alert('Complete os campos')
        } else {
            const db = getDatabase();
            set(ref(db, `${base64.encode(user.email)}/funcionarios/${base64.encode(nomeFuncionario + cargoFuncionario)}`), {
                nome: nomeFuncionario,
                cargo: cargoFuncionario
            }).then(() => handleClose()).catch(() => console.log());


        }

    }

    async function registerServico() {
        if (!valorServico || !nomeServico) {
            window.alert('Complete os campos')
        } else {
            const db = getDatabase();
            set(ref(db, `${base64.encode(user.email)}/servicos/${base64.encode(valorServico + nomeServico)}`), {
                nome: nomeServico,
                valor: valorServico,
                descricao: descricaoServico
            }).then(() => handleCloseRegister()).catch(error => console.log('ERRO AO CADASTRAR SERVIÇO:::::::', error));


        }

    }

    async function registerProduct() {
        if (!nomeProduto || !valorProduto) {
            window.alert('Complete os campos')
        } else {
            const db = getDatabase();
            set(ref(db, `${base64.encode(user.email)}/produtos/${base64.encode(valorProduto + nomeProduto)}`), {
                nome: nomeProduto,
                valor: valorProduto,
                descricao: descricaoProduto
            }).then(() => handleCloseProduct()).catch(error => console.log('ERRO AO CADASTRAR SERVIÇO:::::::', error));


        }

    }


    const fetchBookedAppointments = async () => {
        const dbRef = ref(database, `${base64.encode(user.email)}/agendamentos`); // Referência para a coleção 'clientes'

        // Escuta mudanças em tempo real
        onValue(dbRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const dataList = Object.keys(data).map((key) => ({
                    id: key,

                    fotoUrl: data[key].fotoUrl
                }));

                setDataClientes(dataList);

            }
        })
    }


    const handleFilterChange = (e) => {
        const value = e.target.value.toLowerCase(); // Converte o valor do filtro para minúsculas
        setFilterValue(value); // Atualiza o valor do filtro

        const filtered = bookedAppointments.filter((item) =>
            item.nome.toLowerCase().includes(value) ||
            item.employee.toLowerCase().includes(value) ||
            item.time.toLowerCase().includes(value) ||
            item.doses.toLowerCase().includes(value) ||
            item.remedio.toLowerCase().includes(value)
        );

        setFilteredData(filtered); // Atualiza os dados filtrados
    };

    const RenderConnected = () => {
        if (connectednumber) {
            return (
                <GreenBox>Conectado</GreenBox>
            )
        } else {
            return (
                <RedBox>Desconectado</RedBox>
            )
        }
    }


    const RenderPayment = () => {
        if (paymentState.assinatura) {
            return (
                <GreenBox>Assinatura Ativa</GreenBox>
            )
        } else {
            return (
                <RedBox>Assinatura Inativa</RedBox>
            )
        }
    }

    console.log('HORARIOS DISPONÍVEIS::::', horarioManual)


    if (!user) {
        navigate('/loading')
    }

    return (
        <>
       
<div
  style={{
    minHeight: "100vh",
    background: "#f6f8fc",
    padding: "30px",
    fontFamily: "Arial"
  }}
>

    <div
  style={{
    display: "flex",
    gap: "12px",
    marginTop: "20px"
  }}
>
  <button
    onClick={handleOpen}
    style={{
      padding: "12px 18px",
      background: "#2563eb",
      color: "white",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "600"
    }}
  >
    Cadastrar Funcionário
  </button>

  <button
    onClick={handleOpenRegister}
    style={{
      padding: "12px 18px",
      background: "#16a34a",
      color: "white",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "600"
    }}
  >
    Cadastrar Serviço
  </button>

  <button
    onClick={handleOpenProduct}
    style={{
      padding: "12px 18px",
      background: "#dc2626",
      color: "white",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "600"
    }}
  >
    Cadastrar Produto
  </button>

  <button
  onClick={handleOpenQr}
  style={{
    padding: "12px 18px",
    background: "#f59e0b",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600"
  }}
>
  Exibir QR Code
</button>
</div>

  {/* cards */}

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
      gap: "20px"
    }}
  >

    {data.map((item,index)=>(

      <div
        key={index}
        style={{
          background: "white",
          padding: "25px",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0,0,0,.05)"
        }}
      >

        <p
          style={{
            color:"#8b8b8b",
            fontSize:"14px"
          }}
        >
          {item.title}
        </p>

        <h2
          style={{
            marginTop:"10px",
            fontSize:"32px"
          }}
        >
          {item.value}
        </h2>

        <small>{item.percentage}</small>

      </div>

    ))}

  </div>


  {/* serviços funcionários produtos */}

  <div
    style={{
      display:"grid",
      gridTemplateColumns:"repeat(3,1fr)",
      gap:"20px",
      marginTop:"30px"
    }}
  >

    

    {/* serviços */}

    <div
      style={{
        background:"white",
        padding:"20px",
        borderRadius:"18px"
      }}
    >


      <h2>Serviços</h2>

      {Object.entries(userData?.servicos || {}).map(([key,item])=>(

        <div
          key={key}
          style={{
            marginTop:"15px",
            border:"1px solid #eee",
            padding:"14px",
            borderRadius:"12px",
            display:"flex",
            justifyContent:"space-between"
          }}
        >

          <div>

            <strong>{item.nome}</strong>

            <p>R$ {item.valor}</p>

          </div>

          <button
            onClick={()=>onDeleteService(item)}
            style={{
              border:"none",
              width:"30px",
              height:"30px",
              borderRadius:"50%",
              cursor:"pointer",
              background:"#fee2e2",
              color:"red"
            }}
          >
            ×
          </button>

        </div>

      ))}

    </div>


    {/* funcionarios */}

    <div
      style={{
        background:"white",
        padding:"20px",
        borderRadius:"18px"
      }}
    >

      <h2>Funcionários</h2>

      {Object.entries(userData?.funcionarios || {}).map(([key,item])=>(

        <div
          key={key}
          style={{
            marginTop:"15px",
            border:"1px solid #eee",
            padding:"14px",
            borderRadius:"12px",
            display:"flex",
            justifyContent:"space-between"
          }}
        >

          <div>

            <strong>{item.nome}</strong>

            <p>{item.cargo}</p>

          </div>

        </div>

      ))}

    </div>


    {/* produtos */}

    <div
      style={{
        background:"white",
        padding:"20px",
        borderRadius:"18px"
      }}
    >

      <h2>Produtos</h2>

      {Object.entries(userData?.produtos || {}).map(([key,item])=>(

        <div
          key={key}
          style={{
            marginTop:"15px",
            border:"1px solid #eee",
            padding:"14px",
            borderRadius:"12px"
          }}
        >

          <strong>{item.nome}</strong>

          <p>R$ {item.valor}</p>

        </div>

      ))}

    </div>

  </div>


  {/* tabela */}

  <div
    style={{
      background:"white",
      marginTop:"30px",
      padding:"20px",
      borderRadius:"20px"
    }}
  >

    <h2>Agendamentos</h2>

    <input
      placeholder="Pesquisar..."
      value={filterValue}
      onChange={(e)=>handleFilterChange(e)}
      style={{
        width:"100%",
        marginTop:"15px",
        padding:"14px",
        border:"1px solid #ddd",
        borderRadius:"12px"
      }}
    />

    <table
      style={{
        width:"100%",
        marginTop:"20px",
        borderCollapse:"collapse"
      }}
    >

      <thead>

      <tr>

        <th
          style={{
            textAlign:"left",
            padding:"15px",
            background:"#f8fafc"
          }}
        >
          Cliente
        </th>

        <th
          style={{
            textAlign:"left",
            padding:"15px",
            background:"#f8fafc"
          }}
        >
          Serviço
        </th>

        <th
          style={{
            textAlign:"left",
            padding:"15px",
            background:"#f8fafc"
          }}
        >
          Horário
        </th>

      </tr>

      </thead>

      <tbody>

      {bookedAppointments.map((item)=>(

        <tr key={item.id}>

          <td
            style={{
              padding:"15px",
              borderTop:"1px solid #eee"
            }}
          >
            {item.clientName}
          </td>

          <td
            style={{
              padding:"15px",
              borderTop:"1px solid #eee"
            }}
          >
            {item.service}
          </td>

          <td
            style={{
              padding:"15px",
              borderTop:"1px solid #eee"
            }}
          >
            {item.time}
          </td>

        </tr>

      ))}

      </tbody>

    </table>

  </div>


  {/* botões */}

  <div
    style={{
      display:"flex",
      justifyContent:"flex-end",
      gap:"10px",
      marginTop:"20px"
    }}
  >

    <button
      style={{
        padding:"12px 18px",
        border:"none",
        borderRadius:"12px",
        background:"red",
        color:"white",
        cursor:"pointer"
      }}
    >
      Cancelar
    </button>

    <button
      style={{
        padding:"12px 18px",
        border:"none",
        borderRadius:"12px",
        background:"green",
        color:"white",
        cursor:"pointer"
      }}
    >
      Agendar Manual
    </button>

  </div>


  {/* modal */}

{open && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}
  >
    <div
      style={{
        width: "500px",
        background: "white",
        padding: "30px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)"
      }}
    >
      <h2>Cadastrar Funcionário</h2>

      <input
        value={nomeFuncionario}
        onChange={(e) => setNomeFuncionario(e.target.value)}
        placeholder="Nome do funcionário"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      <input
        value={cargoFuncionario}
        onChange={(e) => setCargoFuncionario(e.target.value)}
        placeholder="Cargo"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px"
        }}
      >
        <button
          onClick={registerFuncionario}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#7c3aed",
            color: "white",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Salvar
        </button>

        <button
          onClick={handleClose}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#e5e7eb",
            color: "#111827",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
)}


{openRegister && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}
  >
    <div
      style={{
        width: "500px",
        background: "white",
        padding: "30px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)"
      }}
    >
      <h2>Cadastrar Serviço</h2>

      <input
        value={nomeServico}
        onChange={(e) => setNomeServico(e.target.value)}
        placeholder="Nome do serviço"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      <input
        value={valorServico}
        onChange={(e) => setValorServico(e.target.value)}
        placeholder="Valor"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px"
        }}
      >
        <button
          onClick={registerServico}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#2563eb",
            color: "white",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Salvar
        </button>

        <button
          onClick={handleCloseRegister}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#e5e7eb",
            color: "#111827",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
)}

{openProduct && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}
  >
    <div
      style={{
        width: "500px",
        background: "white",
        padding: "30px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)"
      }}
    >
      <h2>Cadastrar Produto</h2>

      <input
        value={nomeProduto}
        onChange={(e) => setNomeProduto(e.target.value)}
        placeholder="Nome do produto"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      <input
        value={valorProduto}
        onChange={(e) => setValorProduto(e.target.value)}
        placeholder="Valor"
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ddd",
          borderRadius: "12px",
          outline: "none"
        }}
      />

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px"
        }}
      >
        <button
          onClick={registerProduct}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#16a34a",
            color: "white",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Salvar
        </button>

        <button
          onClick={handleCloseProduct}
          style={{
            flex: 1,
            padding: "14px",
            border: "none",
            background: "#e5e7eb",
            color: "#111827",
            borderRadius: "12px",
            cursor: "pointer",
            fontWeight: "600"
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
)}


</div>

{openQr && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}
  >
    <div
      style={{
        width: "420px",
        background: "white",
        padding: "30px",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,.15)"
      }}
    >
      <h2>Escaneie o QR Code</h2>

      <img
        src={qrCodeUrl}
        alt="QR Code"
        style={{
          width: "250px",
          height: "250px",
          objectFit: "contain",
          border: "1px solid #eee",
          padding: "10px",
          borderRadius: "12px"
        }}
      />

      <button
        onClick={handleCloseQr}
        style={{
          width: "100%",
          padding: "14px",
          border: "none",
          background: "#e5e7eb",
          color: "#111827",
          borderRadius: "12px",
          cursor: "pointer",
          fontWeight: "600"
        }}
      >
        Fechar
      </button>
    </div>
  </div>
)}
</>


)
}
   
    export default Measurement;